module.exports = __webpack_public_path__ + "static/media/RW.04bc762d.svg";